import { gql } from "@apollo/client";

import { OrgChartUserNodeFragment } from "./get-org-chart-organization-members-query";

export default gql`
  ${OrgChartUserNodeFragment}
  query getOrgChartOrganizationMemberQuery(
    $organizationId: Int!
    $userId: Int!
  ) {
    organization(pk: $organizationId) {
      id
      members(userId: $userId) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            user {
              ...OrgChartUserNode
            }
          }
        }
      }
    }
  }
`;
